import { Box, Button, Center, Flex, FormControl, FormLabel, Input, Text, VStack } from "@chakra-ui/react"
import Footer from '../../components/common/Footer'
import Header from '../../components/common/Header'
import HelpdeskSideNav from '../../components/common/helpdeskSidenav'

const TrackRequest = () => {
  return (
      <>
          <Header />
          <Center bgColor="#3362AB" height="260px" width="100%" textAlign="center">
              <Text color="white" fontSize="48px" fontWeight="800">Track Help Request</Text>
          </Center>
          <Box bg='#F9F8F8' height='100%'>
              <Flex width='90%' mx='auto' pt='80px'>
                  <HelpdeskSideNav />
                  <VStack width="50%" spacing="2.4rem" height="auto" mb="4rem" mx='auto' bg="white" padding="4rem">
                      <FormControl>
                          <FormLabel mb="1rem" fontWeight="700" color="brand.3" fontSize={14}>Email Address<Text as="span" color="red"> * </Text></FormLabel>
                          <Input bg="inputText.500" placeholder="Enter email here" fontSize={12} />

                      </FormControl>
                      <FormControl >
                          <FormLabel mb="1rem" fontWeight="700" color="brand.3" fontSize={14}>Ticket ID<Text as="span" color="red"> * </Text></FormLabel>
                          <Input bg="inputText.500" placeholder="Enter ticket ID" fontSize={12} />

                      </FormControl>
                      <Flex justifyContent='flex-end' gap="2rem">
                          <Button
                              mt={4}
                              colorScheme="red"
                              size="lg"
                              px={6}
                              fontSize='14px'

                              borderRadius='0px'
                          >
                              {' '}
                              TRACK REQUEST
                          </Button>
                          <Button
                              mt={4}
                              colorScheme="red"
                              size="lg"
                              px={6}
                              fontSize='14px'

                              borderRadius='0px'
                          >
                              {' '}
                              CANCEL
                          </Button>
                      </Flex>
                  </VStack>
              </Flex>
          </Box>
          <Footer />
      </>
  )
}

export default TrackRequest